import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditCourse from "../components/EditCourse";


const CourseCategoryEdit = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Course  </h5><Breadcrumb title="Edit Course" /></div>

        {/* UsersListLayer */}
        <EditCourse />

     

    </>
  );
};

export default CourseCategoryEdit; 